import React, { useMemo } from 'react';
import styles from './LoginPageDesktop.module.scss';
import LoginForm from './Features/LoginForm/LoginForm';
import ForgotPasswordLink from './Features/ForgotPasswordLink/ForgotPasswordLink';
import AuthBetweenLink from '../../Features/AuthBetweenLink/AuthBetweenLink';
import Terms from '../../Features/Terms/Terms';
import { TFunction, useTranslation } from 'react-i18next';
import background from '../../../../assets/images/auth_background.png';
import AuthorizationLayoutDesktop from '../../Layout/AuthorizationLayout';
import alStyles from '../../Layout/AuthorizationLayout.module.scss';
import AuthorizationLayoutTablet from '../../Layout/Tablet/AuthorizationLayoutTablet';

const getSubtitle = (t: TFunction<'translation', undefined>) => (
  <>
    <span>{t('login.intro.subtitle1')}</span>&nbsp;<span className={alStyles.subtitleBold}>{t('login.intro.subtitle2')}</span>
  </>
);

function LoginPageDesktop() {
  const { t } = useTranslation();
  const subtitle = useMemo(() => getSubtitle(t), [t]);
  return (
    <AuthorizationLayoutDesktop background={background} subtitle={subtitle} title={t('login.intro.title')}>
      <AuthorizationLayoutTablet>
        <h1 className={styles.title}>{t('login.action.title')}</h1>
        <span className={styles.subtitle}>{t('login.action.info')}</span>
        <LoginForm />
        <AuthBetweenLink title={t('login.action.signup1')} link={'/auth/signup'} linkText={t('login.action.signup2')} />
        <ForgotPasswordLink />
        <Terms />
      </AuthorizationLayoutTablet>
    </AuthorizationLayoutDesktop>
  );
}

export default LoginPageDesktop;
